"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const react_modal_1 = __importDefault(require("react-modal"));
const ButtonWeb_1 = __importDefault(require("./common/ButtonWeb"));
const userHandlers_1 = require("../handlers/userHandlers");
const ConfirmationRemoveAccountModal = ({ modalVisible, setModalVisible, data, setData, mainModalSetVisible }) => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'account.remove_account' });
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, { isOpen: modalVisible, onRequestClose: () => {
            setModalVisible(false);
        }, contentLabel: t('remove_account'), className: "modal-body confirmation-modal", overlayClassName: "modal-overlay", appElement: document.getElementById("app-root"), children: [(0, jsx_runtime_1.jsx)("span", { className: "subtitle-bold", children: t('confirmation_title') }), (0, jsx_runtime_1.jsx)("span", { className: "subtitle red", children: t('confirmation_subtitle') }), (0, jsx_runtime_1.jsxs)("div", { className: "buttons", children: [(0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Red", onClick: () => {
                            setModalVisible(false);
                            (0, userHandlers_1.deleteUserHandler)(data.password, () => mainModalSetVisible(false));
                            setData({ password: '' });
                        }, children: t('confirmation_button') }), (0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { type: "Blue", onClick: () => {
                            setModalVisible(false);
                            mainModalSetVisible(false);
                            setData({ password: '' });
                        }, children: t('confirmation_cancel') })] })] }));
};
exports.default = ConfirmationRemoveAccountModal;
